<template>
  <div class="popper-body">
    <div class="container p-2">
      <section v-if="isExternalService()" class="provider-container">
        <div class="col-md-10">
          <div class="col-12">
            <label class="data-name">Proveedor:</label>
          </div>
          <div class="panel-resizable col-12">
            <span class="text-nowrap font-weight-bold">
              {{ value.companyName }}
            </span>
          </div>
        </div>

        <div class="col-md-10 mt-2">
          <div class="col-12">
            <label class="data-name">Municipio:</label>
          </div>
          <div class="panel-resizable col-12">
            <span class="text-nowrap font-weight-bold">
              {{ value.municipalityName }}
            </span>
          </div>
        </div>
        <div class="col-md-10 mt-2">
          <div class="col-12">
            <label class="data-name">Lugar de Servicio:</label>
          </div>
          <div class="panel-resizable col-12">
            <span class="text-nowrap font-weight-bold">
              {{ value.locationName }}
            </span>
          </div>
        </div>
        <div class="col-md-10 mt-2">
          <div class="col-12">
            <label class="data-name">Disciplina:</label>
          </div>
          <div class="panel-resizable col-12">
            <span class="text-nowrap font-weight-bold">
              {{ value.disciplineName }}
            </span>
          </div>
        </div>
      </section>
      <div class="col-md-12 mt-2 d-flex pr-0 justify-content-between">
        <div class="mr-2">
          <div class="col-12">
            <label class="data-name">Estudiante:</label>
          </div>
          <div class="panel-resizable col-12">
            <span class="text-nowrap font-weight-bold">
              {{ value.studentName + ' - ' + value.studentSieId }}
            </span>
          </div>
        </div>
        <div>
          <button
            v-if="isRemoveBtnVisible"
            class="ab-btn  btn-outline-danger mr-1"
            @click="$emit('remove-admission', { ...value, index })"
          >
            <i class="fas fa-times-circle" />
          </button>
          <button
            v-if="!editMode && !this.isInOtherCompany"
            class="ab-btn  ab-btn-success"
            @click="$emit('edit-admission', { ...value, index })"
          >
            <i class="fas fa-edit" />
          </button>
        </div>
      </div>
      <div class="col-md-10 mt-2">
        <div class="col-12">
          <label class="data-name">Edad:</label>
        </div>
        <div class="col-12">
          <span class="text-nowrap">
            {{ value.studentAge }}
          </span>
        </div>
      </div>
      <div class="col-md-10 mt-2">
        <div class="col-12">
          <label class="data-name">Numero de referido:</label>
        </div>
        <div class="col-12">
          <span class="text-nowrap">
            {{ value.referralNumber }}
          </span>
        </div>
      </div>
      <div class="col-md-12 mt-2">
        <div class="col-12">
          <label class="data-name">Escuela:</label>
        </div>
        <div class="col-12">
          <span>
            {{ value.schoolCode + ' - ' + value.schoolName }}
          </span>
        </div>
      </div>
      <div class="col-md-10 mt-2">
        <div class="col-12">
          <label class="data-name">Frecuencia:</label>
        </div>
        <div class="col-12">
          <span class="text-nowrap">
            {{ value.frequency }}
          </span>
        </div>
      </div>
      <div class="col-md-10 mt-2">
        <div class="col-12">
          <label class="data-name">Modalidad:</label>
        </div>
        <div class="col-12">
          <span class="text-nowrap">
            {{ value.modality }}
          </span>
        </div>
      </div>
      <div class="col-md-12 mt-2 duration-container">
        <div class="row">
          <div class="duration-container_label col-6">
            <div>
              <label class="data-name">Duracion:</label>
            </div>
            <div>
              <span class="text-nowrap">
                {{ value.duration }}
              </span>
            </div>
          </div>
          <div class="col-6">
            <div class="pagination-container row">
              <button
                class="fas fa-chevron-left col-2"
                :disabled="index <= 1"
                @click="changeIndex(index - 1, index)"
              />
              <div class="content col-5">
                <span>
                  {{ index }}
                  <span style="color:#e2e2e2;">&nbsp;/&nbsp;</span>
                  {{ totalMounted }}
                </span>
              </div>
              <button
                class="fas fa-chevron-right col-2"
                :disabled="index >= totalMounted"
                @click="changeIndex(index + 1, index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopperStudentInformation',
  components: {},
  props: {
    index: {
      type: Number,
      default: () => 0,
    },
    totalMounted: {
      type: Number,
      default: () => 0,
    },
    value: {
      type: Object,
      default: () => null,
    },
    isInOtherCompany: {
      type: Boolean,
      default: () => null,
    },
    isInOtherLocation: {
      type: Boolean,
      default: () => null,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    pagination: {
      currentPage: 1,
      totalItemCount: 1,
      pageCount: 1,
      count: 1,
      pageSize: 5,
    },
  }),
  computed: {
    isRemoveBtnVisible() {
      return (
        !this.editMode &&
        !this.isInOtherCompany &&
        this.userHasPermissions(
          'provider.calendar.specialist.availability.remove.coordination.bygroup'
        )
      );
    },
  },
  methods: {
    changeIndex(nextIndex, previousIndex) {
      this.$emit('changeIndex', { nextIndex, previousIndex });
    },
    isExternalService() {
      return this.isInOtherLocation || this.isInOtherCompany;
    },
  },
};
</script>

<style scoped>
.data-name {
  white-space: nowrap;
  text-align: right;
  margin-bottom: 0px;
}

.provider-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  padding: 16px 0;
}
.popper-body {
  text-align: justify;
  width: max-content;
  min-width: 300px;
  background-color: #fff;
}

.success {
  padding-right: 4px;
}

.pagination-container button {
  border: none;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: #f7f7f7;
}
.pagination-container {
  width: 112px;
  height: 32px;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  margin-top: 10px;
  float: right;
}

.duration-container {
  display: inline-block;
}

.duration-container_label {
  display: inline;
}
.duration-container_label div {
  width: min-content;
}
.content {
  padding: 0px;
  justify-content: center;
  align-items: center;
  display: flex;
  margin-left: 2px;
  margin-right: 2px;
}
.content span {
  font-weight: bold;
}
.col-12 {
  padding: 0;
}

::v-deep .ab-btn.ab-btn-success {
  width: 38px !important;
  height: 40px !important;
  padding: 8px !important;
}
</style>
